// Streaming self-serve activation gating — mirrors cdn-activate.ts / waap-service.ts.
//
// Two separate streaming products are self-serve activatable:
//   - Penguin (Live Streaming / LMS): Internal.HLSLowLatency → /services/live/:id
//   - Lens    (Media Service / VOD):  External.SwiftCoder   → /services/vod/:id
//
// Each backend activation POSTs to /services with the matching provider_id; the
// backend resolves the customer org from the JWT and mints the upstream tenant.

/** Provider codename for Penguin (Live Streaming / LMS). */
export const PENGUIN_PROVIDER = 'penguin';

/** Provider codename for Lens (Media Service / VOD). */
export const LENS_PROVIDER = 'lens';

/** Route to a provisioned Penguin (live) service console. */
export function liveConsoleRoute(serviceId: string): string {
  return `/services/live/${serviceId}`;
}

/** Route to a provisioned Lens (VOD/Cloud Encoding) service console. */
export function vodConsoleRoute(serviceId: string): string {
  return `/services/vod/${serviceId}`;
}

/** Activation metadata for each streaming provider. */
export const STREAMING_PRODUCTS = {
  penguin: {
    displayName: 'Live Streaming',
    serviceName: 'Live Streaming',
    description:
      'Enterprise live streaming (LMS) with live transcoding, DRM and multi-CDN delivery.',
    /** Hero sub-heading shown on the activation landing. */
    activateLede:
      'Provision a live streaming edge, then start adding channels with live transcoding presets, DRM and multi-CDN delivery — it only takes a moment.',
    consoleRoute: liveConsoleRoute,
  },
  lens: {
    displayName: 'Media Service',
    serviceName: 'Media Service',
    description:
      'On-demand video (VOD) transcoding, packaging and adaptive-bitrate streaming.',
    /** Hero sub-heading shown on the activation landing. */
    activateLede:
      'Provision a VOD media workspace, then start submitting jobs from watch folders or the API — adaptive-bitrate output is ready in minutes.',
    consoleRoute: vodConsoleRoute,
  },
} as const;

export type StreamingProviderName = keyof typeof STREAMING_PRODUCTS;
